import { ChevronDown } from 'lucide-react'

/**
 * Los dos campos que pide el modal de devolver, de muestra.
 *
 * Vive en el paso 4 del recorrido: explica la elección de vacante y columna sin
 * abrir el modal de un candidato real, así nadie corre el riesgo de reactivar a
 * alguien mientras ve el tutorial. No responde al tap ni al foco a propósito:
 * es una ilustración, no un formulario.
 */
const Campo = ({ etiqueta, texto }: { etiqueta: string; texto: string }) => (
  <div className="flex-1 min-w-0">
    <p className="text-xs font-medium text-gray-700 mb-1">{etiqueta}</p>
    <div className="flex items-center justify-between gap-2 px-3 py-2 rounded-lg bg-[#F6F9FB]">
      <span className="text-xs text-gray-400 truncate">{texto}</span>
      <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" />
    </div>
  </div>
)

export function CamposDeDevolucion() {
  return (
    <div
      aria-hidden="true"
      className="flex items-start gap-3 rounded-xl border border-[#E0E0E0] p-3"
    >
      <Campo etiqueta="Vacante" texto="Selecciona la vacante" />
      <Campo etiqueta="Columna de destino" texto="Selecciona la columna" />
    </div>
  )
}

export default CamposDeDevolucion
